module.exports = __WEBPACK_EXTERNAL_MODULE__codemirror6_adapter_js__;